import 'babel-polyfill';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
//import getMuiTheme from '@material-ui/core/styles/getMuiTheme';
// document.initAppTime = new Date().getTime();

// import '@ungap/global-this';
// (function () {
//     let __magic__ = {};
//     if (typeof globalThis === 'object') return;
//     Object.prototype.__defineGetter__('__magic__', function () {
//         return this;
//     });
//     __magic__.globalThis = __magic__; // lolwat
//     delete Object.prototype.__magic__;
// })();
class AppContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fontFamily: undefined,
        };

        //DEBUG ROUTER!
        this.history = createBrowserHistory();
        // console.log('debugRoutes', this.history);
        this.history.listen((location, action) => {
            // console.log('debugRoutes', location.pathname);
        });
    }

    componentDidCatch(error, info) {
        console.error('componentDidCatch', error, info);
    }

    setFontFamily = (fontFamily) => {
        this.setState({ fontFamily });
    };

    setPrimaryColor = (primaryColor) => {
        this.setState({ primaryColor });
    };

    setSecondaryColor = (secondaryColor) => {
        this.setState({ secondaryColor });
    };

    render() {
        const theme = createMuiTheme({
            // primary: {
            //     main: this.state.primaryColor, //'#0b00e6', //'rgb(17,130,204)', //'rgb(27,30,126)'
            // },
            // secondary: {
            //     main: this.state.secondaryColor, //'#0b00e6', //'rgb(17,130,204)', //'rgb(27,30,126)'
            // },
            palette: {
                custom: {
                    yellow: '#FFFA39',
                    green: '#EBF4DF',
                    lightBrown: '#F7F0E1',
                    lilac: '#F7EDF9',
                    blueW: '#0b00e6',
                },
            },
            overrides: {
                MuiFormControl: {
                    root: {
                        verticalAlign: 'baseline',
                    },
                },
            },
            typography: {
                fontFamily: this.state.fontFamily !== undefined ? this.state.fontFamily : 'Quicksand, HelveticaNeue-Light',
            },
        });
        return (
            <Router history={this.history}>
                <MuiThemeProvider theme={theme}>
                    <App
                        setFontFamily={this.setFontFamily}
                        setPrimaryColor={this.setPrimaryColor}
                        setSecondaryColor={this.setSecondaryColor}
                    />
                </MuiThemeProvider>
            </Router>
        );
    }
}

ReactDOM.render(<AppContainer />, document.getElementById('root'));
//registerServiceWorker();
unregister();
